import {
  Avatar,
  Dialog,
  DialogContent,
  Grid,
  IconButton,
  makeStyles,
  withWidth,
} from "@material-ui/core";
import { red } from "@material-ui/core/colors";
import PropTypes from "prop-types";
import React from "react";
import { confirmable, createConfirmation } from "react-confirm";
import FullScreenDialog from "../../../components/FormDialog/FormDialog";
import QRCode from "qrcode.react";

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 345,
  },
  media: {
    height: 0,
    paddingTop: "56.25%", // 16:9
  },
  expand: {
    transform: "rotate(0deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: "rotate(180deg)",
  },
  avatar: {
    backgroundColor: red[500],
  },
}));

function QRCodeDialog(props) {
  const { title, order, width, proceed } = props;
  const [openDialog, setOpenDialog] = React.useState(true);

  const handleCloseDialog = () => {
    setOpenDialog(false);
    proceed();
  };

  return (
    <div>
      <FullScreenDialog
        disableBackdropClick
        maxWidth={width !== "xs" ? "sm" : false}
        fullScreen={width === "xs"}
        title={props.title}
        scroll="body"
        open={openDialog}
        handleClose={handleCloseDialog}
      >
        <DialogContent style={{ padding: "24px" }}>
          <Grid
            container
            item
            xs={12}
            justify="center"
            alignItems="center"
            direction="column"
          >
            <QRCode
              value={order.id}
              className="reservation-barcode"
              size={width === "xs" ? 250 : 400}
            />
            <h5>{title}</h5>
            {/* <h5>{order.id}</h5> */}
          </Grid>
        </DialogContent>
      </FullScreenDialog>
    </div>
  );
}

QRCodeDialog.propTypes = {
  width: PropTypes.oneOf(["lg", "md", "sm", "xl", "xs"]).isRequired,
  cancel: PropTypes.func,
};
export function showQRCodeDialog(title, order, handleGetList, options = {}) {
  return createConfirmation(confirmable(withWidth()(QRCodeDialog)))({
    title,
    order,
    handleGetList,
    ...options,
  });
}
